import { useState } from "react";
import { useInView } from "react-intersection-observer";
import { SanitizedFeedSectionArticle } from "@typings/Cue";
import axios from "axios";

export const useLoadMoreEventsGallery = (
  initialList: SanitizedFeedSectionArticle[],
  pageSize: number,
  awardType: string,
  year: string | undefined
) => {
  const [articleList, setArticleList] = useState(initialList);
  const [hasMoreArticles, setHasMoreArticles] = useState(
    initialList.length >= pageSize
  );
  const [isLoading, setIsLoading] = useState(false);

  const handleLoadMore = async () => {
    if (isLoading) return;
    if (!hasMoreArticles) return;

    setIsLoading(true);

    const page = articleList.length / pageSize + 1;

    const newArticles = await fetchEventsAwardsGalleryMoreData(
      page,
      awardType,
      year
    );

    if (newArticles.length < pageSize) {
      setHasMoreArticles(false);
    }

    setArticleList((prev) => [...prev, ...newArticles]);
    setIsLoading(false);
  };

  const { ref } = useInView({
    threshold: 0,
    onChange: (inView) => {
      if (!inView) return;
      handleLoadMore();
    },
  });

  return {
    articleList,
    hasMoreArticles,
    ref,
  };
};

const fetchEventsAwardsGalleryMoreData = async function (
  page: number,
  awardType: string,
  year?: string
): Promise<SanitizedFeedSectionArticle[]> {
  try {
    const response = await axios.post<SanitizedFeedSectionArticle[]>(
      "/_plat/api/v1/event-awards-gallery-more-stories",
      { page, awardType, year }
    );

    return response.data || [];
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error(
      "fetchEventsAwardsGalleryMoreData: - Error in fetching pulse data",
      error
    );

    return [];
  }
};
